export const messages = {
  en: {
    housekeepingServPoolUser: {
      title: 'Service Order Flow',
      currentStaff: 'Current Staff',
      previousStaff: 'Previous Staff',
      startTime: 'Start Time',
      endTime: 'End Time',
      event: 'Event',
      status: 'Status',
      remark: 'Remark'
    }
  },
  zh: {
    housekeepingServPoolUser: {
      title: '服务工单流转',
      currentStaff: '当前处理员工',
      previousStaff: '上一节点处理员工',
      startTime: '工单开始时间',
      endTime: '工单结束时间',
      event: '事件',
      status: '员工处理状态',
      remark: '处理说明'
    }
  }
}